function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m11.681808 7.510671-7.6814916 6.326546v6.828169a.66661529.66660997 0 0 0 .6666153.66661l4.6688068-.01208a.66661529.66660997 0 0 0 .6632822-.666613v-3.987577a.66661529.66660997 0 0 1 .6666153-.666609h2.666461a.66661529.66660997 0 0 1 .666616.666609v3.984661a.66661529.66660997 0 0 0 .666615.668693l4.66714.01292a.66661529.66660997 0 0 0 .666616-.666614v-6.832752l-7.679825-6.321963a.50787752.50787347 0 0 0-.637451 0zm12.133648 4.300051-3.483065-2.871005v-5.77076A.49996146.49995747 0 0 0 19.83243 2.669h-2.333154a.49996146.49995747 0 0 0-.499961.499957v3.02516l-3.730129-3.068906a1.9998459 1.9998299 0 0 0-2.541471 0L.18144407 11.810722a.49996146.49995747 0 0 0-.0666615.704107l1.06241813 1.291557a.49996146.49995747 0 0 0 .704529.06791l9.8000783-8.071814a.50787752.50787347 0 0 1 .637451 0l9.800494 8.071814a.49996146.49995747 0 0 0 .704113-.06666l1.062418-1.291557a.49996146.49995747 0 0 0-.07083-.705357z",
    style: {
      strokeWidth: 0.0416633,
      fill: "var(--primary-color)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f5d617cecc2fb010786c713187fcc44c.svg";
export { ForwardRef as ReactComponent };